<script>
  import {VueMaskDirective as mask} from 'v-mask'
  import service from '../../../../domain/arrematantes/services'
  import BtnStatus from './BtnStatus.vue'
  import BtnStatusConfirmar from './ConfirmStatus'

  export default {
    components: {
      BtnStatus,
      BtnStatusConfirmar
    },
    nome: 'painel-aprovacao-online',
    directives: {mask},
    data () {
      return {
        pendencias: null,
        pendenciasVisualizadas: []
      }
    },
    computed: {
      pendenciasFiltradas () {
        return this.pendencias
        /* if (!this.pendencias) {
          return null
        }
        return this.pendencias.filter(p => !this.pendenciasVisualizadas.includes(p.id)) */
      }
    },
    mounted () {
    },
    activated () {
    },
    created () {
      this.$loaderOverlay.open().message('Aguarde enquanto carregamos as informações iniciais')
      this.$interval = setInterval(() => {
        this.load()
      }, 30000)
      this.load()
    },
    beforeDestroy () {
      window.clearInterval(this.$interval)
    },
    deactivated () {
      window.clearInterval(this.$interval)
      this.$destroy() // no keep-alive
    },
    watch: {},
    methods: {
      load () {
        service.consultaAprovacoes()
          .then((response) => {
            this.$loaderOverlay.hide()
            this.pendencias = response.data
          })
          .catch((response) => {
            this.$loaderOverlay.hide()
            console.log(response)
          })
      },
      visualizar (p) {
        this.pendenciasVisualizadas.push(p.id)
      }
    }
  }
</script>

<template>
  <div>
    <div class="wrapper-md">
      <div class="row">
        <a :href="'/#/website/arrematantes/' + p.id" target="_blank" class="col-md-3 col-sm-6 hover-items" v-for="p in pendenciasFiltradas">
          <div class="panel wrapper">
            <div class="m-t-none font-bold">{{ p.apelido }}</div>
            <div class="m-t-none">{{ p.pessoa.nome }}</div>
            <!--<div class="m-t-none">{{ p.pessoa.cpf ||  p.pessoa.cnpj }}</div>-->
            <div class="m-t-none">Solicitado {{ moment(p.solicitacaoAprovacaoData.date).format('LLL') }}</div>
          </div>
        </a>
      </div>
      <div v-if="!pendencias || pendenciasFiltradas.length === 0">
        Nenhuma interação necessária até o momento
      </div>
      <div class="m-t" v-if="pendencias && pendencias.length > 0 && pendencias.length !== pendenciasFiltradas.length">
        <div class="m-b-xs">Você ocultou algumas pendencias por tê-las visualizado.</div>
        <a class="btn btn-primary" @click="pendenciasVisualizadas = []">Reativar pendencias ocultadas</a>
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// PainelAprovacao.vue?7d364625